import { helper } from '@ember/component/helper';
import dayName from 'garaje/utils/day-name';

export function dayNameHelper([day]: [day: Day]): string {
  return dayName(day);
}

export default helper(dayNameHelper);
